import { render, staticRenderFns } from "./DepartmentRole.vue?vue&type=template&id=8b512b40&"
import script from "./DepartmentRole.vue?vue&type=script&lang=js&"
export * from "./DepartmentRole.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports